import { useIntl } from '@/intl'
import { FilterableCarsAvailable } from '@/scopes/checkout/components/services/CarRentalFilteringService/FilterableCars/FilterableCarsAvailable'
import { useCarRentalServiceStore } from '@/scopes/checkout/components/services/CarRentalFilteringService/store'
import { useService } from '@/scopes/checkout/domain/hooks'
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetContentWrapper,
  SheetHeader,
  SheetOverlay,
  SheetPortal,
  tok,
} from '@sunwebgroup/ui-components'
import * as React from 'react'
import { styled } from 'styled-components'
import { ServiceType } from '../../../domain/types'

const StyledSheetContent = styled(SheetContent)`
  background-color: ${tok('semantics_views_tinted_background_color')};
  ${SheetContentWrapper}{
    padding: 0;
  }
`

export function UpgradeCarsListView({ open }: { open: boolean }) {
  const { service } = useService(ServiceType.CarRentalFiltering)
  const intl = useIntl()

  const { setCarIsBeingUpgraded } = useCarRentalServiceStore()
  if (!service)
    return null

  return (
    <Sheet modal open={open}>
      <SheetPortal>
        <SheetOverlay onClick={() => setCarIsBeingUpgraded(false)} />
        <StyledSheetContent $side="bottom" onEscapeKeyDown={() => setCarIsBeingUpgraded(false)}>
          <SheetHeader>
            <SheetClose onClick={() => setCarIsBeingUpgraded(false)}>{intl.formatMessage({ id: 'close' })}</SheetClose>
          </SheetHeader>
          <FilterableCarsAvailable />
        </StyledSheetContent>
      </SheetPortal>
    </Sheet>
  )
}
